<template>
    <div class="__action-part-hyros">
        <div class="layout-row flex flex-center gap-40 margin-b-30">
            <select-field
		            class="flex"
		            placeholder="Select an action to trigger"
                caption="Action"
                :loading="spin"
                @input="actionChanged($event)"
                :options="actions"
                label="caption"
                v-model="automation.type_id"/>

            <div class="form_group">
              <v-switch label="Use the customer optin email?" :value="automation.send_to_optin_email"
                        v-model="automation.send_to_optin_email"  @change="updated()"
                        info="When checked (default), the customer's optin email will be used when the automation is triggered instead of their payer email in case they're different.">
              </v-switch>
            </div>
        </div>

<!--        <select-field v-if="automation.type_id && acLists.length" class="margin-b-20"-->
<!--            caption="List"-->
<!--            label="caption"-->
<!--            @input="updated"-->
<!--	          :loading="spin"-->
<!--            :options="acLists"-->
<!--            v-model="automation.list"-->
<!--            searchable clearable/>-->

      <div v-if="!!automation.type_id && automation.type_id===3" class="layout-column flex flex-center">
              <span class="" style="text-align: center;margin: 20px">
                An order with product/customer details will be created automatically in Hyros whenever this automation is triggered.</span>
      </div>

	    <select-field v-else-if="automation.type_id"
	                  placeholder="Type a tag to add"
	                  caption="Type and hit Enter to insert a new tag"
	                  @input="updated"
	                  :loading="spin"
	                  readonly="false"
	                  :options="automation.tags||[]"
	                  v-model="automation.tags"
	                  searchable
	                  multiple
	                  taggable />
    </div>
</template>

<script>
import API from "@/api"
import VSwitch from "@/components/base/v-switch";
import SelectField from "@/components/base/select-field";

export default {
  name: 'Hyros',
  components: {
	    SelectField,
        VSwitch,
    },
  mixins: [API],
	props:{
		automation:{
			type:Object,
			// default:()=> {}
		},
		product:{
			type:Object,
		},
		actions:{
			type:Array,
		},
		integration:{
			type:Object,
		},
	},
    data() {
      return {
        spin: false,
	      acLists: [],
      }
    },
    computed: {
			isValid(){
				return (!!this.automation.type_id) &&
						(this.automation.tags && this.automation.tags.length)
			}
    },
    methods: {
      async actionChanged(val) {
				this.$nextTick(()=>{
					this.updated();
				})
      },
	    updated() {
        let caption = "";
				// let tags = this.automation.tags;
        // if (tags && tags.length>0) {
        //   caption = this.automation.tags.join(',');
        // }

        this.automation.action_caption = "";
		    this.$emit('valid', this.isValid)
	    },
    },
    async created() {
	    if (this.automation) {
		    if (!this.automation.content)
			    this.$set(this.automation, 'content', {})
	    }
    },
}
</script>
<style lang="scss" scoped>
.__action-part-hyros {

}
</style>
